// Simple page wrapper for consistent padding/background
export default function Page({ className = "", children }) {
  return (
    <div
      className={`min-h-screen bg-palette-indigo-soft/40 text-palette-gray-primary p-6 ${className}`}
    >
      {children}
    </div>
  );
}
